export default __webpack_public_path__ + "static/media/slide03.ad22e79c.webp";